const Settings = {
  setSetting(data, setData) {
    setData(data);
  },
  changed(settings, data, value, setData) {
    var newData = {
      ...settings,
      [data]: value,
    };

    setData(newData);
  },
};

export default Settings;
